var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrowLeftRec(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.16602 6.6666L5.83268 9.99999M5.83268 9.99999L9.16602 13.3333M5.83268 9.99999H14.166M9.66602 18.3334H10.3327C13.1329 18.3334 14.5331 18.3334 15.6026 17.7884C16.5434 17.309 17.3083 16.5441 17.7877 15.6033C18.3327 14.5337 18.3327 13.1336 18.3327 10.3333V9.66669C18.3327 6.86643 18.3327 5.46629 17.7877 4.39673C17.3083 3.45592 16.5434 2.69102 15.6026 2.21165C14.5331 1.66669 13.1329 1.66669 10.3327 1.66669H9.66602C6.86575 1.66669 5.46562 1.66669 4.39606 2.21165C3.45525 2.69102 2.69035 3.45592 2.21098 4.39673C1.66602 5.46629 1.66602 6.86643 1.66602 9.66669V10.3333C1.66602 13.1336 1.66602 14.5337 2.21098 15.6033C2.69035 16.5441 3.45525 17.309 4.39606 17.7884C5.46562 18.3334 6.86575 18.3334 9.66602 18.3334Z",
    stroke: "#23252F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeftRec);
export default __webpack_public_path__ + "static/media/arrow-left-rec.148c524a21bc28323b5b7fac901cf2d2.svg";
export { ForwardRef as ReactComponent };